import { BlogPost } from "@/models/dtos";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import { ToastNotification } from "@/models/ToastNotification";
import { IEmploymentService } from "@/interfaces/IEmploymentService";

const client = myContainer.get<IEmploymentService>(TYPES.IEmploymentService);

interface NewsState {
  blogPost: BlogPost[];
  newPost: NewPost;
}
interface NewPost {
  id?: string;
  title: string;
  body: string;
}
export default {
  state: {
    blogPost: [] as BlogPost[],
    newPost: {} as NewPost,
  },
  getters: {
    getBlogPost(state: NewsState) {
      return state.blogPost;
    },
    getBlogPostById: (state: NewsState) => (id: string) => {
      return state.blogPost.find((post) => post.id === id);
    },
    getSpecifikBlogPost: (state: NewsState) => (id: string) => {
      return state.blogPost.find((post) => post.id === id);
    },
    getNewPost: (state: NewsState) => state.newPost,
  },
  mutations: {
    ADD_BLOG_POST(state: NewsState, newPost: BlogPost) {
      state.blogPost.push(newPost);
    },
    DELETE_BLOG_POST(state: NewsState, id: string) {
      state.blogPost = state.blogPost.filter((post) => post.id !== id);
    },
    SET_NEW_POST(state: NewsState, newValue: NewPost) {
      state.newPost = newValue;
    },
  },
  actions: {
    async saveNewsData({ commit }: any, newsData: NewPost) {
      let payload;

      if (newsData.id) {
        payload = {
          id: newsData.id,
          title: newsData.title,
          body: newsData.body,
        };
      } else {
        payload = {
          title: newsData.title,
          body: newsData.body,
        };
      }

      const response = await client.JobPosition.CreateBlogPost(payload);
      const newPost = {
        id: response.data,
        ...newsData,
      };
      commit("ADD_BLOG_POST", newPost);
      commit("SET_NEW_POST", { title: "", body: "" });
    },
    async getAllNews({ commit }: any) {
      const response = await client.JobPosition.GetBlogPosts();
      response.forEach((element) => {
        const blog = new BlogPost();
        blog.id = element.id;
        blog.title = element.title;
        blog.body = element.body;
        blog.created = element.created;
        commit("ADD_BLOG_POST", blog);
      });
      return response;
    },
    async deleteBlogPost({ commit, dispatch }: any, id: string) {
      try {
        await client.JobPosition.deleteBlogPost(id);
        commit("DELETE_BLOG_POST", id);

        dispatch(
          "addNotification",
          new ToastNotification("success", "Nyheten borttagen")
        );
      } catch (error: any) {
        dispatch(
          "addNotification",
          new ToastNotification("alert", "Något gick fel. Nyheten ej borttagen")
        );
      }
    },
  },
};
